<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z"
        />
        <path
            fill-rule="evenodd"
            d="M18.8887 10.75c-.5163-2.86397-2.7747-5.12245-5.6387-5.63871V3c0-.69036-.5596-1.25-1.25-1.25s-1.25.55964-1.25 1.25v2.11129C7.88603 5.62755 5.62755 7.88603 5.11129 10.75H3c-.69036 0-1.25.5596-1.25 1.25s.55964 1.25 1.25 1.25h2.11129c.51626 2.864 2.77474 5.1224 5.63871 5.6387V21c0 .6904.5596 1.25 1.25 1.25s1.25-.5596 1.25-1.25v-2.1113c2.864-.5163 5.1224-2.7747 5.6387-5.6387H21c.6904 0 1.25-.5596 1.25-1.25s-.5596-1.25-1.25-1.25h-2.1113ZM16.5 12c0 2.4853-2.0147 4.5-4.5 4.5-2.48528 0-4.5-2.0147-4.5-4.5 0-2.48528 2.01472-4.5 4.5-4.5 2.4853 0 4.5 2.01472 4.5 4.5Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M15 12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3Zm-2 0c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Z"
            clip-rule="evenodd"
        />
        <path
            fill-rule="evenodd"
            d="M5.07089 13C5.5094 16.0657 7.93431 18.4906 11 18.9291V21c0 .5523.4477 1 1 1s1-.4477 1-1v-2.0709c3.0657-.4385 5.4906-2.8634 5.9291-5.9291H21c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2.0709C18.4906 7.93431 16.0657 5.5094 13 5.07089V3c0-.55228-.4477-1-1-1s-1 .44772-1 1v2.07089C7.93431 5.5094 5.5094 7.93431 5.07089 11H3c-.55228 0-1 .4477-1 1s.44772 1 1 1h2.07089ZM7 12c0-2.76142 2.23858-5 5-5 2.7614 0 5 2.23858 5 5 0 2.7614-2.2386 5-5 5-2.76142 0-5-2.2386-5-5Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
